<template>
  <div>
    <h3>Module</h3>
    <vs-breadcrumb class="mt-2">
      <li><router-link to="/surveys">Surveys</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="parentOnlineTrainingLink">Online Training - {{ $translate(surveyTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li aria-current="page" class="active">{{ $translate(moduleTitle) }}</li>
    </vs-breadcrumb>
    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <module-general v-if="item" :module="item" />
        </div>
      </vs-tab>

      <!-- LESSONS -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Lessons' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <module-lessons />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import ModuleGeneral from "./ModuleGeneral.vue";
import ModuleLessons from "./ModuleLessons.vue";

export default {
  components: {
    ModuleGeneral,
    ModuleLessons
  },
  data() {
    return {
      item: null,

      surveyId: '',
      moduleId: '',

      surveyTitle: '',
      moduleTitle: ''
    };
  },
  methods: {
    getItem: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId;
      
      this.$http.get(url)
          .then(resp => {
            console.log("Online Training:", resp.data);

            this.item = resp.data.surveyModule;
            this.surveyTitle = resp.data.surveyTitle;
            this.moduleTitle = resp.data.moduleTitle;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    parentOnlineTrainingLink() {
      return '/surveys/online-training/' + this.surveyId;
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;

    this.getItem();
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
